import type { OrganisationRole } from "@bafe/types";

/** Default combined mail landing after sign-in for workspace members with the User role. */
export const WEBMAIL_HOME = "/webmail/mail/all/unread";

const ACCOUNT_SECTIONS = new Set(["profile", "security", "sessions", "data"]);

export function isMailOnlyOrganisationRole(role: OrganisationRole): boolean {
	return role === "user";
}

/** Personal account settings reachable from webmail; not workspace administration. */
export function isMailOnlyAccountPath(pathname: string): boolean {
	const path = pathname.split("?")[0] ?? pathname;
	if (path === "/manage/account") return true;
	if (!path.startsWith("/manage/account/")) return false;
	const section = path.slice("/manage/account/".length).split("/")[0] ?? "";
	return ACCOUNT_SECTIONS.has(section);
}

export function isBlockedForMailOnlyMember(pathname: string): boolean {
	if (isMailOnlyAccountPath(pathname)) return false;
	if (pathname === "/ai" || pathname.startsWith("/ai/")) return true;
	if (pathname === "/manage" || pathname.startsWith("/manage/")) return true;
	if (pathname === "/mail" || pathname.startsWith("/mail/")) return true;
	if (pathname === "/site" || pathname.startsWith("/site/")) return true;
	if (pathname === "/team" || pathname.startsWith("/team/")) return true;
	if (pathname === "/social" || pathname.startsWith("/social/")) return true;
	if (pathname === "/engage" || pathname.startsWith("/engage/")) return true;
	return false;
}
